import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { invoicesInfiniteQueryOptions } from '@/hooks'
import {
  ALL_INVOICE_STATUSES,
  ALL_INVOICE_VIEWS,
  buildInvoicesQueryOptions,
  InvoicesPage,
} from '@/pages/invoices/InvoicesPage'

const InvoicesSearchSchema = z.object({
  view: z.enum(ALL_INVOICE_VIEWS).default('invoices'),
  status: z.enum(ALL_INVOICE_STATUSES).optional(),
  createdFrom: z.iso.datetime().optional(),
  createdTo: z.iso.datetime().optional(),
  archived: z.boolean().default(false),
})

export const Route = createFileRoute('/_authenticated/_dashboard/invoices/')({
  validateSearch: InvoicesSearchSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureInfiniteQueryData(
      invoicesInfiniteQueryOptions(buildInvoicesQueryOptions(deps.search)),
    ),
  component: InvoicesPage,
})
